var map = {
	"./backgrounds/defectPortraitFaded.png": "eaa8",
	"./backgrounds/foregroundBG.png": "56f0",
	"./backgrounds/ironcladPortraitFaded.png": "8985",
	"./backgrounds/silentPortraitFaded.png": "0249",
	"./backgrounds/watcherPortraitFaded.png": "c929",
	"./buttons/defect.png": "d5ab",
	"./buttons/ironclad.png": "75f1",
	"./buttons/silent.png": "6c99",
	"./buttons/watcher.png": "863a",
	"./cards/base/colorless/attack.png": "92f4",
	"./cards/base/colorless/original/attack.png": "dc15",
	"./cards/base/colorless/original/power.png": "e455",
	"./cards/base/colorless/original/skill.png": "35c7",
	"./cards/base/colorless/power.png": "71af",
	"./cards/base/colorless/skill.png": "9d5c",
	"./cards/base/curse/original/skill.png": "7d0e",
	"./cards/base/curse/skill.png": "751e",
	"./cards/base/defect/attack.png": "bd6f",
	"./cards/base/defect/power.png": "60a3",
	"./cards/base/defect/skill.png": "4df2",
	"./cards/base/ironclad/attack.png": "0642",
	"./cards/base/ironclad/originalpng/attackoriginal.png": "a653",
	"./cards/base/ironclad/originalpng/poweroriginal.png": "dedf",
	"./cards/base/ironclad/originalpng/skilloriginal.png": "f260",
	"./cards/base/ironclad/power.png": "ecc4",
	"./cards/base/ironclad/skill.png": "d8d9",
	"./cards/base/silent/attack.png": "ff7c",
	"./cards/base/silent/original/attack.png": "3b29",
	"./cards/base/silent/original/power.png": "9dbe",
	"./cards/base/silent/original/skill.png": "dc81",
	"./cards/base/silent/power.png": "1f39",
	"./cards/base/silent/skill.png": "f094",
	"./cards/base/watcher/attack.png": "9895",
	"./cards/base/watcher/originalpng/attackoriginal.png": "f723",
	"./cards/base/watcher/originalpng/poweroriginal.png": "0860",
	"./cards/base/watcher/originalpng/skilloriginal.png": "7f12",
	"./cards/base/watcher/power.png": "684e",
	"./cards/base/watcher/skill.png": "7f13",
	"./cards/image/colorless/attack/1no-image.png": "4391",
	"./cards/image/colorless/attack/bite.png": "b945",
	"./cards/image/colorless/attack/dramaticEntrance.png": "72f4",
	"./cards/image/colorless/attack/expunger.png": "3431",
	"./cards/image/colorless/attack/flashOfSteel.png": "78dc",
	"./cards/image/colorless/attack/handOfGreed.png": "737c",
	"./cards/image/colorless/attack/mindBlast.png": "331d",
	"./cards/image/colorless/attack/ritualDagger.png": "3e66",
	"./cards/image/colorless/attack/shiv.png": "a393",
	"./cards/image/colorless/attack/smite.png": "0270",
	"./cards/image/colorless/attack/swiftStrike.png": "8f45",
	"./cards/image/colorless/attack/throughViolence.png": "1515",
	"./cards/image/colorless/power/1no-image.png": "e15d",
	"./cards/image/colorless/power/becomeAlmighty.png": "1797",
	"./cards/image/colorless/power/liveForever.png": "4da7",
	"./cards/image/colorless/power/magnetism.png": "89cd",
	"./cards/image/colorless/power/mayhem.png": "f75f",
	"./cards/image/colorless/power/omega.png": "b340",
	"./cards/image/colorless/power/panache.png": "72b3",
	"./cards/image/colorless/power/sadisticNature.png": "76e4",
	"./cards/image/colorless/skill/1no-image.png": "e76f",
	"./cards/image/colorless/skill/apotheosis.png": "bd7a",
	"./cards/image/colorless/skill/apparition.png": "8040",
	"./cards/image/colorless/skill/bandageUp.png": "f290",
	"./cards/image/colorless/skill/beta.png": "2362",
	"./cards/image/colorless/skill/blind.png": "17b1",
	"./cards/image/colorless/skill/calm.png": "4bb3",
	"./cards/image/colorless/skill/chrysalis.png": "9242",
	"./cards/image/colorless/skill/darkShackles.png": "3f82",
	"./cards/image/colorless/skill/deepBreath.png": "2175",
	"./cards/image/colorless/skill/discovery.png": "8367",
	"./cards/image/colorless/skill/enlightenment.png": "94ff",
	"./cards/image/colorless/skill/fameAndFortune.png": "9e7b",
	"./cards/image/colorless/skill/finesse.png": "28c4",
	"./cards/image/colorless/skill/forethought.png": "ab25",
	"./cards/image/colorless/skill/goodInstincts.png": "3aea",
	"./cards/image/colorless/skill/impatience.png": "672c",
	"./cards/image/colorless/skill/insight.png": "c4ed",
	"./cards/image/colorless/skill/jAX.png": "43f4",
	"./cards/image/colorless/skill/jackOfAllTrades.png": "6033",
	"./cards/image/colorless/skill/madness.png": "3af4",
	"./cards/image/colorless/skill/masterOfStrategy.png": "51b5",
	"./cards/image/colorless/skill/metamorphosis.png": "643b",
	"./cards/image/colorless/skill/miracle.png": "e85b",
	"./cards/image/colorless/skill/panacea.png": "2b5e",
	"./cards/image/colorless/skill/panicButton.png": "60c5",
	"./cards/image/colorless/skill/purity.png": "cd2c",
	"./cards/image/colorless/skill/safety.png": "8236",
	"./cards/image/colorless/skill/secretTechnique.png": "4815",
	"./cards/image/colorless/skill/secretWeapon.png": "47de",
	"./cards/image/colorless/skill/theBomb.png": "f180",
	"./cards/image/colorless/skill/thinkingAhead.png": "3fae",
	"./cards/image/colorless/skill/transmutation.png": "ad0c",
	"./cards/image/colorless/skill/trip.png": "50e5",
	"./cards/image/colorless/skill/violence.png": "f29b",
	"./cards/image/colorless/skill/wrath.png": "23f6",
	"./cards/image/curse/ascendersBane.png": "3d49",
	"./cards/image/curse/clumsy.png": "95a2",
	"./cards/image/curse/curseOfTheBell.png": "afdd",
	"./cards/image/curse/decay.png": "b444",
	"./cards/image/curse/doubt.png": "e0d1",
	"./cards/image/curse/error.png": "41dd",
	"./cards/image/curse/injury.png": "eb30",
	"./cards/image/curse/modCardImage.png": "91fe",
	"./cards/image/curse/necronomicurse.png": "6d12",
	"./cards/image/curse/normality.png": "5946",
	"./cards/image/curse/pain.png": "cfc6",
	"./cards/image/curse/parasite.png": "0790",
	"./cards/image/curse/pride.png": "d627",
	"./cards/image/curse/regret.png": "5cef",
	"./cards/image/curse/shame.png": "7359",
	"./cards/image/curse/writhe.png": "8f29",
	"./cards/image/defect/attack/1no-image.png": "6062",
	"./cards/image/defect/attack/allForOne.png": "5dae",
	"./cards/image/defect/attack/axeKick.png": "5a47",
	"./cards/image/defect/attack/ballLightning.png": "99a7",
	"./cards/image/defect/attack/barrage.png": "3c95",
	"./cards/image/defect/attack/beamCell.png": "3a68",
	"./cards/image/defect/attack/blizzard.png": "2091",
	"./cards/image/defect/attack/bullseye.png": "4956",
	"./cards/image/defect/attack/claw.png": "ec42",
	"./cards/image/defect/attack/coldSnap.png": "b5c8",
	"./cards/image/defect/attack/compileDriver.png": "e73d",
	"./cards/image/defect/attack/coreSurge.png": "7db3",
	"./cards/image/defect/attack/doomAndGloom.png": "10a4",
	"./cards/image/defect/attack/fTL.png": "1a32",
	"./cards/image/defect/attack/goForTheEyes.png": "14de",
	"./cards/image/defect/attack/hyperbeam.png": "711f",
	"./cards/image/defect/attack/melter.png": "1444",
	"./cards/image/defect/attack/meteorStrike.png": "8093",
	"./cards/image/defect/attack/nova.png": "d453",
	"./cards/image/defect/attack/rebound.png": "8a1d",
	"./cards/image/defect/attack/ripAndTear.png": "ab8e",
	"./cards/image/defect/attack/scrape.png": "695d",
	"./cards/image/defect/attack/streamline.png": "2b26",
	"./cards/image/defect/attack/strike.png": "113e",
	"./cards/image/defect/attack/sunder.png": "28c43",
	"./cards/image/defect/attack/sweepingBeam.png": "5740",
	"./cards/image/defect/attack/thunderStrike.png": "c0d3",
	"./cards/image/defect/attack/zap.png": "85d7",
	"./cards/image/defect/power/1no-image.png": "d45e",
	"./cards/image/defect/power/biasedCognition.png": "df78",
	"./cards/image/defect/power/buffer.png": "456b",
	"./cards/image/defect/power/capacitor.png": "bd6d",
	"./cards/image/defect/power/creativeAI.png": "46db",
	"./cards/image/defect/power/defragment.png": "0670",
	"./cards/image/defect/power/echoForm.png": "34b0",
	"./cards/image/defect/power/electrodynamics.png": "176a",
	"./cards/image/defect/power/heatsinks.png": "f68a",
	"./cards/image/defect/power/helloWorld.png": "bb76",
	"./cards/image/defect/power/lightningMastery.png": "090d",
	"./cards/image/defect/power/loop.png": "b9b2",
	"./cards/image/defect/power/machineLearning.png": "a377",
	"./cards/image/defect/power/prime.png": "586f",
	"./cards/image/defect/power/rechargingOrb.png": "6c2d",
	"./cards/image/defect/power/selfRepair.png": "444b",
	"./cards/image/defect/power/staticDischarge.png": "141c",
	"./cards/image/defect/power/storm.png": "abe2",
	"./cards/image/defect/skill/1no-image.png": "e0e6",
	"./cards/image/defect/skill/aggregate.png": "a890",
	"./cards/image/defect/skill/amplify.png": "bd4b",
	"./cards/image/defect/skill/auto-Shields.png": "a755",
	"./cards/image/defect/skill/bootSequence.png": "a2f8",
	"./cards/image/defect/skill/chaos.png": "883b",
	"./cards/image/defect/skill/chargeBattery.png": "fc72",
	"./cards/image/defect/skill/chill.png": "a6fd",
	"./cards/image/defect/skill/consume.png": "2291",
	"./cards/image/defect/skill/coolheaded.png": "131b",
	"./cards/image/defect/skill/darkness.png": "8c7b",
	"./cards/image/defect/skill/defend.png": "818e",
	"./cards/image/defect/skill/doubleEnergy.png": "f796",
	"./cards/image/defect/skill/dualcast.png": "3217",
	"./cards/image/defect/skill/equilibrium.png": "1b89",
	"./cards/image/defect/skill/fission.png": "1270",
	"./cards/image/defect/skill/fluxCapacitor.png": "a99c",
	"./cards/image/defect/skill/forceField.png": "eb39",
	"./cards/image/defect/skill/fusion.png": "1aeb",
	"./cards/image/defect/skill/geneticAlgorithm.png": "50a1",
	"./cards/image/defect/skill/glacier.png": "3542",
	"./cards/image/defect/skill/hologram.png": "7b6c",
	"./cards/image/defect/skill/impulse.png": "8b60",
	"./cards/image/defect/skill/leap.png": "5624",
	"./cards/image/defect/skill/multi-Cast.png": "9eab",
	"./cards/image/defect/skill/overclock.png": "bdd8",
	"./cards/image/defect/skill/rainbow.png": "ed36",
	"./cards/image/defect/skill/reboot.png": "b4f7",
	"./cards/image/defect/skill/recursion.png": "9fed",
	"./cards/image/defect/skill/recycle.png": "2242",
	"./cards/image/defect/skill/reinforcedBody.png": "8b54",
	"./cards/image/defect/skill/reprogram.png": "65a3",
	"./cards/image/defect/skill/seek.png": "7239",
	"./cards/image/defect/skill/skim.png": "a68a",
	"./cards/image/defect/skill/stack.png": "d44d",
	"./cards/image/defect/skill/steamBarrier.png": "12c2",
	"./cards/image/defect/skill/tURBO.png": "d74b",
	"./cards/image/defect/skill/tempest.png": "2d4b",
	"./cards/image/defect/skill/whiteNoise.png": "fd2a",
	"./cards/image/defect/skill/zap.png": "2de9",
	"./cards/image/ironclad/attack/1no-image.png": "a5eb",
	"./cards/image/ironclad/attack/anger.png": "110b",
	"./cards/image/ironclad/attack/bash.png": "ce3a",
	"./cards/image/ironclad/attack/bloodForBlood.png": "a483",
	"./cards/image/ironclad/attack/bludgeon.png": "b4d4",
	"./cards/image/ironclad/attack/bodySlam.png": "4c39",
	"./cards/image/ironclad/attack/carnage.png": "1da2",
	"./cards/image/ironclad/attack/clash.png": "a972",
	"./cards/image/ironclad/attack/cleave.png": "a46f",
	"./cards/image/ironclad/attack/clothesline.png": "798f",
	"./cards/image/ironclad/attack/dropkick.png": "9f80",
	"./cards/image/ironclad/attack/feed.png": "d7f7",
	"./cards/image/ironclad/attack/fiendFire.png": "f233",
	"./cards/image/ironclad/attack/headbutt.png": "84bc",
	"./cards/image/ironclad/attack/heavyBlade.png": "40c8",
	"./cards/image/ironclad/attack/hemokinesis.png": "67d5",
	"./cards/image/ironclad/attack/immolate.png": "a5bb",
	"./cards/image/ironclad/attack/ironWave.png": "9882",
	"./cards/image/ironclad/attack/perfectedStrike.png": "43f9",
	"./cards/image/ironclad/attack/pommelStrike.png": "c27d",
	"./cards/image/ironclad/attack/pummel.png": "04d8",
	"./cards/image/ironclad/attack/rampage.png": "2e1b",
	"./cards/image/ironclad/attack/reaper.png": "0b60",
	"./cards/image/ironclad/attack/recklessCharge.png": "4935",
	"./cards/image/ironclad/attack/searingBlow.png": "018e",
	"./cards/image/ironclad/attack/severSoul.png": "59a7",
	"./cards/image/ironclad/attack/strike.png": "794d",
	"./cards/image/ironclad/attack/swordBoomerang.png": "796a",
	"./cards/image/ironclad/attack/thunderclap.png": "50aa",
	"./cards/image/ironclad/attack/twinStrike.png": "5744",
	"./cards/image/ironclad/attack/uppercut.png": "c3c6",
	"./cards/image/ironclad/attack/whirlwind.png": "0043",
	"./cards/image/ironclad/attack/wildStrike.png": "9b26",
	"./cards/image/ironclad/power/barricade.png": "af97",
	"./cards/image/ironclad/power/berserk.png": "c0c0",
	"./cards/image/ironclad/power/brutality.png": "4b66",
	"./cards/image/ironclad/power/combust.png": "cff9",
	"./cards/image/ironclad/power/corruption.png": "3a49",
	"./cards/image/ironclad/power/darkEmbrace.png": "3df4",
	"./cards/image/ironclad/power/demonForm.png": "5c48",
	"./cards/image/ironclad/power/evolve.png": "699e",
	"./cards/image/ironclad/power/feelNoPain.png": "5ee5",
	"./cards/image/ironclad/power/fireBreathing.png": "0d2b",
	"./cards/image/ironclad/power/inflame.png": "8fc0",
	"./cards/image/ironclad/power/juggernaut.png": "05aa",
	"./cards/image/ironclad/power/metallicize.png": "f56a",
	"./cards/image/ironclad/power/rupture.png": "51f9",
	"./cards/image/ironclad/skill/armaments.png": "6eff",
	"./cards/image/ironclad/skill/battleTrance.png": "1489",
	"./cards/image/ironclad/skill/bloodletting.png": "5941",
	"./cards/image/ironclad/skill/burningPact.png": "bfda",
	"./cards/image/ironclad/skill/clothesline.png": "c270",
	"./cards/image/ironclad/skill/defend.png": "5d08",
	"./cards/image/ironclad/skill/disarm.png": "9ed8",
	"./cards/image/ironclad/skill/doubleTap.png": "b101",
	"./cards/image/ironclad/skill/dualWield.png": "f5be",
	"./cards/image/ironclad/skill/entrench.png": "ca79",
	"./cards/image/ironclad/skill/exhume.png": "d070",
	"./cards/image/ironclad/skill/flameBarrier.png": "19c8",
	"./cards/image/ironclad/skill/flex.png": "59b3",
	"./cards/image/ironclad/skill/ghostlyArmor.png": "b145",
	"./cards/image/ironclad/skill/havoc.png": "97b3",
	"./cards/image/ironclad/skill/impervious.png": "4124",
	"./cards/image/ironclad/skill/infernalBlade.png": "d08d",
	"./cards/image/ironclad/skill/intimidate.png": "d527",
	"./cards/image/ironclad/skill/limitBreak.png": "76d5",
	"./cards/image/ironclad/skill/offering.png": "007e",
	"./cards/image/ironclad/skill/powerThrough.png": "9d41",
	"./cards/image/ironclad/skill/rage.png": "f355",
	"./cards/image/ironclad/skill/searingBlow.png": "a99c3",
	"./cards/image/ironclad/skill/secondWind.png": "b87f",
	"./cards/image/ironclad/skill/seeingRed.png": "041a",
	"./cards/image/ironclad/skill/sentinel.png": "4947",
	"./cards/image/ironclad/skill/shockwave.png": "dd24",
	"./cards/image/ironclad/skill/shrugItOff.png": "61b4",
	"./cards/image/ironclad/skill/spotWeakness.png": "c69a1",
	"./cards/image/ironclad/skill/trueGrit.png": "f51c",
	"./cards/image/ironclad/skill/warcry.png": "3c977",
	"./cards/image/silent/attack/1no-image.png": "606d",
	"./cards/image/silent/attack/all-OutAttack.png": "a00c",
	"./cards/image/silent/attack/backstab.png": "19f2",
	"./cards/image/silent/attack/bane.png": "dd65",
	"./cards/image/silent/attack/choke.png": "bea0",
	"./cards/image/silent/attack/daggerSpray.png": "a080",
	"./cards/image/silent/attack/daggerThrow.png": "5dff",
	"./cards/image/silent/attack/dash.png": "47cb",
	"./cards/image/silent/attack/dieDieDie.png": "57d0",
	"./cards/image/silent/attack/endlessAgony.png": "d24d",
	"./cards/image/silent/attack/eviscerate.png": "ca62",
	"./cards/image/silent/attack/finisher.png": "a75a",
	"./cards/image/silent/attack/flechettes.png": "8911",
	"./cards/image/silent/attack/flyingKnee.png": "3103",
	"./cards/image/silent/attack/glassKnife.png": "9cb8",
	"./cards/image/silent/attack/grandFinale.png": "98c5",
	"./cards/image/silent/attack/heelHook.png": "2abb",
	"./cards/image/silent/attack/masterfulStab.png": "be58",
	"./cards/image/silent/attack/neutralize.png": "c054",
	"./cards/image/silent/attack/poisonedStab.png": "1ad5",
	"./cards/image/silent/attack/predator.png": "f8cc",
	"./cards/image/silent/attack/quickSlash.png": "2191",
	"./cards/image/silent/attack/riddleWithHoles.png": "2c3f",
	"./cards/image/silent/attack/skewer.png": "4efa",
	"./cards/image/silent/attack/slice.png": "d2cf",
	"./cards/image/silent/attack/sneakyStrike.png": "7f72",
	"./cards/image/silent/attack/strike.png": "f8bb",
	"./cards/image/silent/attack/suckerPunch.png": "692c",
	"./cards/image/silent/attack/unload.png": "a8a5",
	"./cards/image/silent/power/aThousandCuts.png": "7162",
	"./cards/image/silent/power/accuracy.png": "5f2a",
	"./cards/image/silent/power/afterImage.png": "194e",
	"./cards/image/silent/power/caltrops.png": "559d",
	"./cards/image/silent/power/envenom.png": "eb51",
	"./cards/image/silent/power/footwork.png": "8808",
	"./cards/image/silent/power/infiniteBlades.png": "5882",
	"./cards/image/silent/power/noxiousFumes.png": "0284c",
	"./cards/image/silent/power/toolsOfTheTrade.png": "d54b",
	"./cards/image/silent/power/venomology.png": "e62a",
	"./cards/image/silent/power/well-LaidPlans.png": "03d8",
	"./cards/image/silent/power/wraithForm.png": "0687",
	"./cards/image/silent/skill/acrobatics.png": "a4b1",
	"./cards/image/silent/skill/adrenaline.png": "e9ca",
	"./cards/image/silent/skill/alchemize.png": "8d54",
	"./cards/image/silent/skill/backflip.png": "da3b",
	"./cards/image/silent/skill/bladeDance.png": "c79e",
	"./cards/image/silent/skill/blur.png": "56e9",
	"./cards/image/silent/skill/bouncingFlask.png": "46e2",
	"./cards/image/silent/skill/bulletTime.png": "8655",
	"./cards/image/silent/skill/burst.png": "f989",
	"./cards/image/silent/skill/calculatedGamble.png": "a4f2",
	"./cards/image/silent/skill/catalyst.png": "fd6a",
	"./cards/image/silent/skill/cloakAndDagger.png": "2a95",
	"./cards/image/silent/skill/concentrate.png": "06c7",
	"./cards/image/silent/skill/corpseExplosion.png": "17c7",
	"./cards/image/silent/skill/cripplingCloud.png": "5123",
	"./cards/image/silent/skill/deadlyPoison.png": "ca1b",
	"./cards/image/silent/skill/defend.png": "66c2",
	"./cards/image/silent/skill/deflect.png": "94e1",
	"./cards/image/silent/skill/distraction.png": "5f17",
	"./cards/image/silent/skill/dodgeAndRoll.png": "c8a7",
	"./cards/image/silent/skill/doppelganger.png": "62c3",
	"./cards/image/silent/skill/escapePlan.png": "ffca",
	"./cards/image/silent/skill/expertise.png": "c1ac",
	"./cards/image/silent/skill/hide.png": "ffae",
	"./cards/image/silent/skill/legSweep.png": "71fb",
	"./cards/image/silent/skill/malaise.png": "e330",
	"./cards/image/silent/skill/nightmare.png": "1479",
	"./cards/image/silent/skill/outmaneuver.png": "25b3",
	"./cards/image/silent/skill/phantasmalKiller.png": "c535",
	"./cards/image/silent/skill/piercingWail.png": "29bc",
	"./cards/image/silent/skill/prepared.png": "f95f",
	"./cards/image/silent/skill/reflex.png": "77a8",
	"./cards/image/silent/skill/setup.png": "4ecf",
	"./cards/image/silent/skill/stormOfSteel.png": "11f6",
	"./cards/image/silent/skill/survivor.png": "4ba0",
	"./cards/image/silent/skill/tactician.png": "9022",
	"./cards/image/silent/skill/terror.png": "6f31",
	"./cards/image/watcher/attack/1no-image.png": "9553",
	"./cards/image/watcher/attack/bowlingBash.png": "b478",
	"./cards/image/watcher/attack/brilliance.png": "c12f",
	"./cards/image/watcher/attack/carveReality.png": "413d",
	"./cards/image/watcher/attack/conclude.png": "035d",
	"./cards/image/watcher/attack/consecrate.png": "b4f0",
	"./cards/image/watcher/attack/crushJoints.png": "025f",
	"./cards/image/watcher/attack/cutThroughFate.png": "6eae",
	"./cards/image/watcher/attack/emptyFist.png": "91a9",
	"./cards/image/watcher/attack/eruption.png": "0572",
	"./cards/image/watcher/attack/fearNoEvil.png": "892a",
	"./cards/image/watcher/attack/flurryOfBlows.png": "95f2",
	"./cards/image/watcher/attack/flyingSleeves.png": "c313",
	"./cards/image/watcher/attack/follow-Up.png": "e718",
	"./cards/image/watcher/attack/justLucky.png": "dc6a",
	"./cards/image/watcher/attack/lessonLearned.png": "631c",
	"./cards/image/watcher/attack/ragnarok.png": "1b40",
	"./cards/image/watcher/attack/reachHeaven.png": "1f4b",
	"./cards/image/watcher/attack/sandsOfTime.png": "c0a6",
	"./cards/image/watcher/attack/sashWhip.png": "6135",
	"./cards/image/watcher/attack/signatureMove.png": "8b61",
	"./cards/image/watcher/attack/strike.png": "713a",
	"./cards/image/watcher/attack/talkToTheHand.png": "d30d",
	"./cards/image/watcher/attack/tantrum.png": "8b2d",
	"./cards/image/watcher/attack/wallop.png": "15ca",
	"./cards/image/watcher/attack/weave.png": "8463",
	"./cards/image/watcher/attack/wheelKick.png": "e17f",
	"./cards/image/watcher/attack/windmillStrike.png": "43ee",
	"./cards/image/watcher/power/1no-image.png": "656c",
	"./cards/image/watcher/power/battleHymn.png": "647f",
	"./cards/image/watcher/power/devaForm.png": "7d26",
	"./cards/image/watcher/power/devotion.png": "5af1",
	"./cards/image/watcher/power/establishment.png": "1855",
	"./cards/image/watcher/power/fasting.png": "f5d2",
	"./cards/image/watcher/power/foresight.png": "61a0",
	"./cards/image/watcher/power/likeWater.png": "2a61",
	"./cards/image/watcher/power/masterReality.png": "c9ec",
	"./cards/image/watcher/power/mentalFortress.png": "28d5",
	"./cards/image/watcher/power/nirvana.png": "3d71",
	"./cards/image/watcher/power/rushdown.png": "347d",
	"./cards/image/watcher/power/study.png": "e1b4",
	"./cards/image/watcher/skill/1no-image.png": "bec8",
	"./cards/image/watcher/skill/alpha.png": "0fc0",
	"./cards/image/watcher/skill/blasphemy.png": "bfdf",
	"./cards/image/watcher/skill/calm.png": "06707",
	"./cards/image/watcher/skill/collect.png": "d018",
	"./cards/image/watcher/skill/conjureBlade.png": "c008",
	"./cards/image/watcher/skill/crescendo.png": "6195",
	"./cards/image/watcher/skill/deceiveReality.png": "5d15",
	"./cards/image/watcher/skill/defend.png": "6347",
	"./cards/image/watcher/skill/deusExMachina.png": "e4d0",
	"./cards/image/watcher/skill/emptyBody.png": "959d",
	"./cards/image/watcher/skill/emptyMind.png": "5f3e",
	"./cards/image/watcher/skill/evaluate.png": "7b17",
	"./cards/image/watcher/skill/foreignInfluence.png": "b8e1",
	"./cards/image/watcher/skill/halt.png": "6190",
	"./cards/image/watcher/skill/indignation.png": "64db",
	"./cards/image/watcher/skill/innerPeace.png": "ce3a2",
	"./cards/image/watcher/skill/judgment.png": "e506",
	"./cards/image/watcher/skill/meditate.png": "9e26",
	"./cards/image/watcher/skill/omniscience.png": "1334",
	"./cards/image/watcher/skill/perseverance.png": "ac12",
	"./cards/image/watcher/skill/pray.png": "c4cb",
	"./cards/image/watcher/skill/pressurePoints.png": "d0ac",
	"./cards/image/watcher/skill/prostrate.png": "000b",
	"./cards/image/watcher/skill/protect.png": "39c6",
	"./cards/image/watcher/skill/sanctity.png": "116a",
	"./cards/image/watcher/skill/scrawl.png": "1a17",
	"./cards/image/watcher/skill/simmeringFury.png": "cefd",
	"./cards/image/watcher/skill/spiritShield.png": "b64a",
	"./cards/image/watcher/skill/swivel.png": "c421",
	"./cards/image/watcher/skill/thirdEye.png": "4490",
	"./cards/image/watcher/skill/tranquility.png": "dea0",
	"./cards/image/watcher/skill/unraveling.png": "b53f",
	"./cards/image/watcher/skill/vault.png": "7aa7",
	"./cards/image/watcher/skill/vigilance.png": "a6cf",
	"./cards/image/watcher/skill/waveOfTheHand.png": "16a9",
	"./cards/image/watcher/skill/wish.png": "fbae",
	"./cards/image/watcher/skill/worship.png": "4246",
	"./cards/image/watcher/skill/wreathOfFlame.png": "7b68",
	"./cards/mana/colorless.png": "2fea",
	"./cards/mana/defect.png": "36b2",
	"./cards/mana/ironclad.png": "52cf",
	"./cards/mana/silent.png": "712b",
	"./cards/mana/watcher.png": "767d",
	"./cards/plus/noplus.png": "264b",
	"./cards/plus/plus.png": "a0c4",
	"./cards/rarity/common/banner.png": "193b",
	"./cards/rarity/common/frame/attack.png": "d171",
	"./cards/rarity/common/frame/original/attackoriginal.png": "9ab3",
	"./cards/rarity/common/frame/original/poweroriginal.png": "f607",
	"./cards/rarity/common/frame/original/skilloriginal.png": "4202",
	"./cards/rarity/common/frame/power.png": "c083",
	"./cards/rarity/common/frame/skill.png": "1c36",
	"./cards/rarity/rare/banner.png": "4fab",
	"./cards/rarity/rare/frame/attack.png": "3795",
	"./cards/rarity/rare/frame/original/attack.png": "210e",
	"./cards/rarity/rare/frame/original/power.png": "9ec1",
	"./cards/rarity/rare/frame/original/skill.png": "c35f",
	"./cards/rarity/rare/frame/power.png": "9d27",
	"./cards/rarity/rare/frame/skill.png": "3b74",
	"./cards/rarity/uncommon/banner.png": "8fba",
	"./cards/rarity/uncommon/frame/attack.png": "afaa",
	"./cards/rarity/uncommon/frame/original/attack.png": "17cd",
	"./cards/rarity/uncommon/frame/original/power.png": "6248",
	"./cards/rarity/uncommon/frame/original/skill.png": "dfaa",
	"./cards/rarity/uncommon/frame/power.png": "4df3",
	"./cards/rarity/uncommon/frame/skill.png": "fff3",
	"./cards/tier/x.png": "5436",
	"./chatbot/bubble.png": "9e01",
	"./chatbot/neow.png": "a488",
	"./cursor/magnifier.png": "f342",
	"./cursor/mouse.png": "892a2",
	"./metadata/main-old.png": "5386",
	"./metadata/main.png": "d654",
	"./metadata/spirespylogo-square.png": "954b",
	"./relics/akabeko.png": "33a0",
	"./relics/anchor.png": "4aab",
	"./relics/ancientTeaSet.png": "0db7",
	"./relics/anvil.png": "6ad8",
	"./relics/artOfWar.png": "27d3",
	"./relics/astrolabe.png": "444d",
	"./relics/bagOfMarbles.png": "5c19",
	"./relics/bagOfPreparation.png": "45ad",
	"./relics/bellows.png": "8bc7",
	"./relics/bird-FacedUrn.png": "b736",
	"./relics/blackBlood.png": "3ff9",
	"./relics/blackStar.png": "79f5",
	"./relics/bloodOfGifted.png": "874f",
	"./relics/bloodVial.png": "1af5",
	"./relics/bloodyIdol.png": "4ed5",
	"./relics/blueCandle.png": "6112",
	"./relics/bluePill.png": "27b8",
	"./relics/bottledFlame.png": "780b",
	"./relics/bottledLightning.png": "38c4",
	"./relics/bottledTornado.png": "a72a",
	"./relics/bowlerHat.png": "e417",
	"./relics/brimstone.png": "579c",
	"./relics/bronzeScales.png": "8797",
	"./relics/burningBlood.png": "6376",
	"./relics/bustedCrown.png": "961f",
	"./relics/calipers.png": "1a4d",
	"./relics/callingBell.png": "4a13",
	"./relics/cantUseRelic.png": "7b6e",
	"./relics/captainsWheel.png": "8ca4",
	"./relics/cauldron.png": "e4d5",
	"./relics/centennialPuzzle.png": "cac6",
	"./relics/ceramicFish.png": "d36f",
	"./relics/championBelt.png": "8b60a",
	"./relics/charonsAshes.png": "f800",
	"./relics/chemicalX.png": "cd7b",
	"./relics/circlet.png": "f7f4",
	"./relics/cloakClasp.png": "50d5",
	"./relics/clockworkSouvenir.png": "755c",
	"./relics/coffeeDripper.png": "5357",
	"./relics/compass.png": "0570",
	"./relics/crackedCore.png": "775a",
	"./relics/crownOfThorns.png": "0a64",
	"./relics/cultistHeadpice.png": "423b",
	"./relics/cursedBlood.png": "a622",
	"./relics/cursedKey.png": "41ec",
	"./relics/damaru.png": "0579",
	"./relics/darkstonePeriapt.png": "51ea",
	"./relics/dataDisk.png": "6d8c",
	"./relics/deadBranch.png": "b13a",
	"./relics/derpRock.png": "7bc1",
	"./relics/dodecahedron_s.png": "328c",
	"./relics/dollysMirror.png": "4369",
	"./relics/dreamCatcher.png": "5203",
	"./relics/du-VuDoll.png": "8328",
	"./relics/duality.png": "e774",
	"./relics/ectoplasm.png": "f757",
	"./relics/egg1.png": "a66c",
	"./relics/egg2.png": "e620",
	"./relics/egg3.png": "163f",
	"./relics/emerald.png": "b9e9",
	"./relics/emotionChip.png": "d026",
	"./relics/emptyCage.png": "7318",
	"./relics/enchiridion.png": "6c6e",
	"./relics/equilibrium.png": "2735",
	"./relics/error.png": "e17a",
	"./relics/eternalFeather.png": "9512",
	"./relics/faceOfCleric.png": "a396",
	"./relics/fossilizedHelix.png": "9986",
	"./relics/frozenCore.png": "aefa",
	"./relics/frozenEgg.png": "a948",
	"./relics/frozenEye.png": "3fff",
	"./relics/fusionHammer.png": "fa6b",
	"./relics/gamblingChip.png": "07cd",
	"./relics/ggg.png": "af8c",
	"./relics/ginger.png": "ff67",
	"./relics/girya.png": "cfe7",
	"./relics/gold-PlatedCables.png": "3c8a",
	"./relics/goldTooth.png": "0024",
	"./relics/goldenEye.png": "77c2",
	"./relics/goldenIdol.png": "89ea",
	"./relics/gremlinHorn.png": "ca08",
	"./relics/gremlinVisage.png": "69d8",
	"./relics/gyoza.png": "7e10",
	"./relics/handDrill.png": "abd9",
	"./relics/happyFlower.png": "b5c0",
	"./relics/headband.png": "4c8a",
	"./relics/holyWater.png": "7caa",
	"./relics/hornCleat.png": "515a",
	"./relics/hotPotato.png": "80d9",
	"./relics/hoveringKite.png": "a6c5",
	"./relics/iceCream.png": "575c",
	"./relics/incenseBurner.png": "0506",
	"./relics/inkBottle.png": "c148",
	"./relics/inserter.png": "4b94",
	"./relics/juzuBracelet.png": "cb5d",
	"./relics/keyRing.png": "2026",
	"./relics/kindling.png": "828f",
	"./relics/kunai.png": "bb0c",
	"./relics/lamentUsed.png": "cdd4",
	"./relics/lantern.png": "c297",
	"./relics/leesWaffle.png": "2ef7",
	"./relics/letterOpener.png": "7473",
	"./relics/lives.png": "6acb",
	"./relics/livingBlood.png": "50d7",
	"./relics/lizardTail.png": "3baa",
	"./relics/lock.png": "8b28",
	"./relics/magicFlower.png": "9fe4",
	"./relics/mango.png": "84f3",
	"./relics/markOfPain.png": "91bb",
	"./relics/markOfTheBloom.png": "14d5",
	"./relics/matryoshka.png": "8e1d",
	"./relics/mawBank.png": "8fbb",
	"./relics/mealTicket.png": "e1ec",
	"./relics/meatOnTheBone.png": "8461",
	"./relics/medicalKit.png": "5884",
	"./relics/melange.png": "922d",
	"./relics/membershipCard.png": "009d",
	"./relics/mercuryHourglass.png": "a0fb",
	"./relics/mindOfTheBloom.png": "ea11",
	"./relics/moltenEgg.png": "ff49",
	"./relics/monocle.png": "fb83",
	"./relics/mummifiedHand.png": "62aa",
	"./relics/nLothsHungryFace.png": "eff6",
	"./relics/necronomicon.png": "bbd7",
	"./relics/neowsLament.png": "eb7b",
	"./relics/nilrysCodex.png": "b3f6",
	"./relics/ninjaScroll.png": "e0c9",
	"./relics/nlothsGift.png": "5bdf",
	"./relics/nuclearBattery.png": "c958",
	"./relics/nullStone.png": "896b",
	"./relics/nullStoneUsed.png": "d02e",
	"./relics/nunchaku.png": "e86c",
	"./relics/octohedron.png": "c41a",
	"./relics/oddMushroom.png": "8422",
	"./relics/oddlySmoothStone.png": "c355",
	"./relics/oldCoin.png": "61df",
	"./relics/omamori.png": "50c0",
	"./relics/orangePellets.png": "b22e",
	"./relics/orichalcum.png": "9e97",
	"./relics/ornamentalFan.png": "0e6f",
	"./relics/orrery.png": "da97",
	"./relics/owlDoll.png": "bcf1",
	"./relics/pandorasBox.png": "2077",
	"./relics/pantograph.png": "df58",
	"./relics/paperKrane.png": "290a",
	"./relics/paperPhrog.png": "d046",
	"./relics/peacePipe.png": "ef5b",
	"./relics/pear.png": "db48",
	"./relics/penNib.png": "c56d",
	"./relics/philosophersStone.png": "5dc7",
	"./relics/pocketwatch.png": "f549",
	"./relics/potionBelt.png": "b333",
	"./relics/practiceLock.png": "1ce7",
	"./relics/prayerWheel.png": "7cf2",
	"./relics/preservedInsect.png": "3329",
	"./relics/pureWater.png": "78f7",
	"./relics/questionCard.png": "5654",
	"./relics/redCirclet.png": "f830",
	"./relics/redMask.png": "f1e8",
	"./relics/redPill.png": "e99d",
	"./relics/redSkull.png": "12d9",
	"./relics/regalPillow.png": "9178",
	"./relics/ringOfTheSerpent.png": "7afb",
	"./relics/ringOfTheSnake.png": "a7be",
	"./relics/runicCapacitor.png": "1121",
	"./relics/runicCube.png": "a79c",
	"./relics/runicDodecahedron.png": "a4ac",
	"./relics/runicDome.png": "7750",
	"./relics/runicPyramid.png": "c86b",
	"./relics/runicSphere.png": "b7c6",
	"./relics/rupee.png": "678d",
	"./relics/sacredBark.png": "a606",
	"./relics/self-FormingClay.png": "50ff",
	"./relics/serpentRing.png": "e42e",
	"./relics/shovel.png": "b932",
	"./relics/shuriken.png": "695c",
	"./relics/singingBowl.png": "98d1",
	"./relics/slaversCollar.png": "33f3",
	"./relics/sling.png": "41f4",
	"./relics/slingOfCourage.png": "5766",
	"./relics/smilingMask.png": "fb13",
	"./relics/sneckoEye.png": "a60f",
	"./relics/sneckoSkull.png": "8d6d",
	"./relics/sozu.png": "254e",
	"./relics/spearHead.png": "16cd",
	"./relics/spiritPoop.png": "62f0",
	"./relics/ssserpentHead.png": "a25b",
	"./relics/stoneCalendar.png": "824c",
	"./relics/strangeSpoon.png": "ed59",
	"./relics/strawberry.png": "a1af",
	"./relics/strikeDummy.png": "0093",
	"./relics/sundial.png": "4882",
	"./relics/symbioticVirus.png": "359c",
	"./relics/teardropLocket.png": "d529",
	"./relics/theAbacus.png": "3798",
	"./relics/theBoot.png": "f67f",
	"./relics/theCourier.png": "93c4",
	"./relics/theSpecimen.png": "4893",
	"./relics/threadAndNeedle.png": "18a8",
	"./relics/tingsha.png": "77f5",
	"./relics/tinyChest.png": "7052",
	"./relics/tinyHouse.png": "166c",
	"./relics/toolbox.png": "628d",
	"./relics/torii.png": "9d70",
	"./relics/toughBandages.png": "dd71",
	"./relics/toxicEgg.png": "1523",
	"./relics/toyOrnithopter.png": "bcd4",
	"./relics/tungstenRod.png": "c5cc",
	"./relics/turnip.png": "47e1",
	"./relics/twistedFunnel.png": "86fa",
	"./relics/unceasingTop.png": "32da",
	"./relics/usedLizardTail.png": "1f15",
	"./relics/usedMatryoshka.png": "f0df",
	"./relics/usedOmamori.png": "476f",
	"./relics/vajra.png": "112c",
	"./relics/velvetChoker.png": "eecf",
	"./relics/violetLotus.png": "382c",
	"./relics/warPaint.png": "695e",
	"./relics/whetstone.png": "7122",
	"./relics/whiteBeastStatue.png": "6e70",
	"./relics/whiteElephant.png": "2d3f",
	"./relics/wristBlade.png": "aadb",
	"./runs/path/boss.png": "f88f",
	"./runs/path/bossChest.png": "b0d0",
	"./runs/path/chest.png": "7329",
	"./runs/path/elite.png": "0a28",
	"./runs/path/monster.png": "6962",
	"./runs/path/rest.png": "c241",
	"./runs/path/shop.png": "2710",
	"./runs/path/unknown.png": "bba7",
	"./runs/path/unknownChest.png": "9a20",
	"./runs/path/unknownMonster.png": "61a2",
	"./runs/path/unknownShop.png": "e5fc",
	"./runuploader/folder.png": "b0ed",
	"./runuploader/thiefupload.png": "73a7",
	"./ui/buttonBlueGold.png": "8bfa",
	"./ui/buttonBlueGrey.png": "c089",
	"./ui/buttonHover.png": "faf0",
	"./ui/buttonHover2.png": "2cf5",
	"./ui/buttonL1.png": "f6f4",
	"./ui/buttonL2.png": "8ce7",
	"./ui/buttonRedGold.png": "448d",
	"./ui/buttonRedGrey.png": "766f",
	"./ui/returnArrow2.png": "d07d",
	"./ui/tipBot.png": "95d0",
	"./ui/tipMid.png": "c89c",
	"./ui/tipTop.png": "b4ce",
	"./ui/toggleButtonBase.png": "e06c",
	"./ui/toggleButtonOverlay2.png": "3770"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d2d";